import logo from "../images/logo.png";
import BG from "../images/BG.png";
import BonusBoard from "../images/BonusBoard.png";
import Trophy from "../images/Trophy.png";
import BackgroundStudio from "../images/HostBG.jpg";
import CatchphraseScreen from "../images/CatchphraseScreen.png";

const GameStates = {
    Loading: "loading",
    MainMenu: "main_menu",
    GameConfig: "game_config",
    Tutorial: "tutorial",
    RoundIntro: "round_intro",
    Playing: "playing",
    RevealAnswer: "reveal_answer",
    RoundSummary: "round_summary",
    EndGame: "end_game",
    SelectingTeams: "selecting_teams",
};

const CatchphraseAnswerModes = {
    Fuzzy: "fuzzy",
    Exact: "exact",
};

const CatchphraseServerOutMessages = {
    StartGameConfig: "catch_out_start_game_config",
    StartTeamsSelection: "catch_out_start_teams_selection",
    StartRoundIntro: "catch_out_start_round_intro",
    StartPhrase: "catch_out_start_phrase",
    PlayerBuzzedIn: "catch_out_player_buzzed_in",
    PlayerGuessed: "catch_out_player_guessed",
    StartGridPhrase: "catch_out_start_grid_phrase",
    RevealAnswer: "catch_out_reveal_answer",
    StartRoundSummary: "catch_out_start_round_summary",
    CancelBuzzIn: "catch_out_cancel_buzz_in",
    BuzzerTimedOut: "catch_out_buzzer_timed_out",
    GridSegmentSelected: "catch_out_grid_segment_selected",
    TeamSelected: "catch_out_team_selected",
    SkipRoundIntro: "catch_out_skip_round_intro",
    PlayerPassed: "catch_out_player_passed",
    TriggerHint: "catch_out_trigger_hint",
    AnswerProcessing: "catch_out_answer_processing",
}

const CatchphraseServerInMessages = {
    GameStarted: "catch_in_game_started",
    OpenGameConfig: "catch_in_open_game_config",
    UpdateGameConfig: "catch_in_update_game_config",
    ConfirmGameConfig: "catch_in_confirm_game_config",
    BackToMenu: "catch_in_back_to_menu",
    TeamSelected: "catch_in_team_selected",
    FinishTeamsSelection: "catch_in_finish_teams_selection",
    FinishRoundIntro: "catch_in_finish_round_intro",
    StartPhraseTimer: "catch_in_start_phrase_timer",
    PlayerBuzzedIn: "catch_in_player_buzzed_in",
    PlayerGuessed: "catch_in_player_guessed",
    PlayerSubmitTypedAnswer: "catch_in_player_submit_typed_answer",
    PlayerTypedProgress: "catch_in_player_typed_progress",
    FinishPhrase: "catch_in_finish_phrase",
    FinishRound: "catch_in_finish_round",
    FinishGridPhrase: "catch_in_finish_grid_phrase",
    FinishRoundSummary: "catch_in_finish_round_summary",
    ReachedEnd: "catch_in_reached_end",
    PlayAgain: "catch_in_catchphrase_game",
    SkipRoundIntro: "catch_in_skip_round_intro",
    HostReady: "catch_in_host_ready",
    SelectGridSegment: "catch_in_select_grid_segment",
    Pass: "catch_in_pass",
    SubmitVoiceAnswer: "catch_in_submit_voice_answer",
    PauseBuzzInTimer: "catch_in_pause_buzz_timer",
    ResumeBuzzInTimer: "catch_in_resume_buzz_timer",
}

const images = [
    logo,
    BG,
    BonusBoard,
    Trophy,
    CatchphraseScreen,
    BackgroundStudio,
];

const fonts = [
    { font: "Impact", path: `../fonts/Impact.ttf` },
    { font: "Futura-PT", path: `../fonts/Futura-PT.ttf` },
];


const WSErrorCodes = {
    1001: "Browser Tab Closing",
    1002: "Malformed framce received",
    1003: "Unsupported frame received",
    1006: "GS ungraceful shutdown / connection refused",
    1011: "Internal Error",
    1012: "Server Restarting",
    1013: "Try again later, server capacity full",
    1014: "Bad Gateway",
    4000: "Gameserver graceful shutdown",
    4050: "Player removed"
};

export {
    images,
    fonts,
    WSErrorCodes,
    GameStates,
    CatchphraseAnswerModes,
    CatchphraseServerOutMessages,
    CatchphraseServerInMessages,
};